import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    organization: {},
    orgLoading: false,
    orgError: null,
    orgMessage: null,
    address: {}
};

const orgSlice = createSlice({
    name: 'organizations',
    initialState,
    reducers: {
        defaultCalling: (state) => {
            state.orgError = null;
            state.orgMessage = null;
        },
        apiCallingStart: (state) => {
            state.orgLoading = true;
            state.orgError = null;
        },
        apiCallingFailure: (state, action) => {
            state.orgLoading = false;
            state.orgError = action.payload;
        },
        getOrg: (state, action) => {
            state.orgLoading = false;
            state.organization = action.payload.data;
        },
        orgUpdate: (state, action) => {
            state.orgLoading = false;
            state.orgMessage = action.payload.message;
            state.organization = action.payload.data;
        },
        setAddress: (state, action) => {
            state.orgLoading = false;
            state.orgMessage = action.payload.message;
            state.address = action.payload.data;
        }
    },
});

export const {
    apiCallingStart,
    apiCallingFailure,
    defaultCalling,
    getOrg,
    orgUpdate,
    setAddress
} = orgSlice.actions;

export default orgSlice.reducer;
